import React from "react";
import Personalisation from "./components/personalisation/personalisation";
import Pillar from "./components/pillar/pillar";

function App(props) {
    const { interactive } = props;
    if (interactive === "all") {
        return (
            <div>
                <Personalisation />
                <div style={{ height: 420 }} />
                <Pillar pillarKey="forward" />
                <div style={{ height: 64 }} />
                <Pillar pillarKey="moment" />
                <div style={{ height: 64 }} />
                <Pillar pillarKey="retro" />
            </div>
        );
    } else {
        switch (interactive) {
            case "personalisation":
                return <Personalisation />;
            case "pillar-forward":
                return <Pillar pillarKey="forward" />;
            case "pillar-moment":
                return <Pillar pillarKey="moment" />;
            case "pillar-retro":
                return <Pillar pillarKey="retro" />;
            default:
                return <p>Unknown interactive ID: "{interactive}"</p>;
        }
    }
}

export default App;
